import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FullWidthSection from '../FullWidthSection'
import { ThemeConsumer } from '../../state'
import HeroTitle from './HeroTitle'

const Container = styled.div`
  text-align: center;
  position: relative;
  padding-top: 10rem;
  background-color: ${({ theme }) => theme.colors.heroBackground};
  color: ${({ theme }) => theme.colors.heroForeground};
  user-select: none;

  @media screen and (max-width: ${({ theme }) =>
      theme.dimensions.mobileBreakpoint - 1}px) {
    padding-top: 6rem;
  }
`

const ParticlesContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0.7;
`

const InnerContainer = styled.div`
  width: 100%;
  display: block;
  padding: 6rem ${({ theme }) => theme.dimensions.contentGutterSize};
  max-width: ${({ theme }) => theme.dimensions.contentWidth};
  margin: 5rem auto 0;
  pointer-events: none;
  z-index: 1;
  position: relative;

  a,
  button {
    position: relative;
    z-index: 1;
    pointer-events: auto;
  }
`

const getParticlesConfig = (theme) => ({
  particles: {
    number: {
      value: 30,
      density: {
        enable: true,
        value_area: 1000
      }
    },
    color: {
      value: theme.colors.interactive
    },
    shape: {
      type: 'circle',
      stroke: {
        width: 0,
        color: '#000000'
      },
      polygon: {
        nb_sides: 5
      }
    },
    opacity: {
      value: 0.7,
      random: false,
      anim: {
        enable: false,
        speed: 0.2,
        opacity_min: 0.1,
        sync: false
      }
    },
    size: {
      value: 2,
      random: true,
      anim: {
        enable: false,
        speed: 80,
        size_min: 0.1,
        sync: false
      }
    },
    line_linked: {
      enable: true,
      distance: 120,
      color: theme.colors.interactive,
      opacity: 0.4,
      width: 1
    },
    move: {
      enable: true,
      speed: 2,
      direction: 'none',
      random: false,
      straight: false,
      out_mode: 'out',
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200
      }
    }
  },
  interactivity: {
    detect_on: 'canvas',
    events: {
      onhover: {
        enable: true,
        mode: 'grab'
      },
      onclick: {
        enable: true,
        mode: 'push'
      },
      resize: true
    },
    modes: {
      grab: {
        distance: 200,
        line_linked: {
          opacity: 1
        }
      },
      bubble: {
        distance: 400,
        size: 80,
        duration: 2,
        opacity: 0.8,
        speed: 3
      },
      repulse: {
        distance: 400,
        duration: 0.4
      },
      push: {
        particles_nb: 4
      },
      remove: {
        particles_nb: 2
      }
    }
  },
  retina_detect: true
})

const Particles = ({ theme }) => {
  useEffect(() => {
    require('particles.js/particles')
    window &&
      window.particlesJS &&
      window.particlesJS('particles-hero-background', getParticlesConfig(theme))
  }, [theme])

  return <ParticlesContainer id="particles-hero-background" />
}

Particles.propTypes = {
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      interactive: PropTypes.string.isRequired
    })
  })
}

const Hero = ({ children }) => (
  <FullWidthSection fullWidthContent>
    <Container>
      <ThemeConsumer>
        {({ theme }) => <Particles key="iohk" theme={theme} />}
      </ThemeConsumer>
      <InnerContainer>{children}</InnerContainer>
    </Container>
  </FullWidthSection>
)

Hero.propTypes = {
  children: PropTypes.node.isRequired
}

export default Hero
export { HeroTitle }
